export enum TopUpEWalletActionTypes {
    REQUEST = '@@e-wallet/top-up/request',
    SUCCESS = '@@e-wallet/top-up/success',
    ERROR = '@@e-wallet/top-up/error'
}
